import React from 'react';
import { Button } from 'reactstrap';
import { AxiosAPI } from '../../../../../../helpers/AxiosAPI';
import { postAPI_GenerateInvite } from '../../../../../../constants/APIs';
import { NotificationManager } from "../../../../../../components/common/react-notifications";

export default function GenerateInvitationLink({
  id
}) {

  const handleCopy = data => {
    AxiosAPI({
      method: 'put',
      url: `${postAPI_GenerateInvite}/${data}/generate-invite-link`,
      data: {
      },
    }).then(resnew => {
      navigator.clipboard.writeText(resnew.data.url);
      NotificationManager.success(
        "",
        "Link copied to clipboard.",
        3000,
        null,
        null,
        "success"
      );
    }).catch(err => console.error(err));
  };

  return (

    <Button
      color="primary"
      size="sm"
      onClick={() => handleCopy(id)}
    >
      Copy Invitation Link
    </Button>

  );
}
